
/**
 * @nullable
 */
export type CreateNotificationBodySender = { [key: string]: unknown } | null;
